import { useQuery } from "@tanstack/react-query";
import { clubApi } from "../../club-api-client";
import { queryKeys } from "../query-keys";

export function useClubSquads(clubId: string | null) {
	return useQuery({
		enabled: !!clubId,
		queryFn: () => {
			if (!clubId) {
				throw new Error("club id required");
			}
			return clubApi.squads.list(clubId);
		},
		queryKey: queryKeys.clubPortal.clubSquads(clubId ?? ""),
	});
}

export function useClubSquadMembers(clubId: string | null, squadId: string | null) {
	return useQuery({
		enabled: !!clubId && !!squadId,
		queryFn: () => {
			if (!squadId) {
				throw new Error("squad id required");
			}
			return clubApi.squads.members(squadId);
		},
		queryKey: queryKeys.clubPortal.clubSquadMembers(clubId ?? "", squadId ?? ""),
	});
}

export function useClubSquadSessions(clubId: string | null, squadId: string | null) {
	return useQuery({
		enabled: !!clubId && !!squadId,
		queryFn: () => {
			if (!squadId) {
				throw new Error("squad id required");
			}
			return clubApi.squads.sessions(squadId);
		},
		queryKey: queryKeys.clubPortal.clubSquadSessions(clubId ?? "", squadId ?? ""),
	});
}
